module.exports = __webpack_public_path__ + "static/media/right.2d514af4.svg";